module.exports = __webpack_public_path__ + "static/media/calorias.a4470076.svg";